import { Link } from 'react-router-dom';
import { useClock, formatUtcStamp } from '../lib/useClock';

export function TopBar() {
  const time = useClock();
  const stamp = formatUtcStamp(time);

  return (
    <div
      className="topbar"
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
        padding: '14px 28px',
        borderBottom: '1px solid var(--ink)',
        fontSize: 10.5,
        textTransform: 'uppercase',
        letterSpacing: 0.8,
        position: 'relative',
        zIndex: 2,
      }}
    >
      <Link
        to="/"
        style={{ color: 'inherit', textDecoration: 'none' }}
        aria-label="Back to dossier home"
      >
        DOSSIER · DMERRITTS · REV. 2026.04
      </Link>
      <Link
        to="/"
        style={{
          textAlign: 'center',
          fontWeight: 600,
          color: 'inherit',
          textDecoration: 'none',
        }}
      >
        // danmerritts.com
      </Link>
      <div
        className="topbar-stamp tabular"
        style={{ textAlign: 'right', opacity: 0.7 }}
      >
        SYS · {stamp}
      </div>
    </div>
  );
}
